import Button, { ButtonProps } from '@mui/material/Button';
import AccountBalanceWalletOutlined from '@mui/icons-material/AccountBalanceWalletOutlined';
import { useWalletAuth } from 'src/hooks/useWalletAuth';

export type ConnectWalletButtonProps = ButtonProps & {
  onClose?: () => void;
};

export function ConnectWalletButton({
  sx,
  onClick,
  onClose,
  ...props
}: ConnectWalletButtonProps) {
  const { signInWallet } = useWalletAuth();
  return (
    <Button
      onClick={(e) => {
        signInWallet({ onFinish: onClose });

        if (!!onClick) {
          onClick(e);
        }
      }}
      variant="contained"
      size="large"
      color="primary"
      startIcon={<AccountBalanceWalletOutlined />}
      {...props}
      sx={{ ...sx }}
    >
      Connect Wallet
    </Button>
  );
}
